module.exports = __webpack_public_path__ + "img/expovina-primavera_01(1).d8cd7c4a.jpg";